'use client';

import * as React from 'react';
import { Switch as SwitchPrimitive } from 'radix-ui';

import { cn } from '../lib/utils';

function Switch({
	className,
	size,
	variant,
	...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & { size?: 'lg'; variant?: 'primary' }) {
	return (
		<SwitchPrimitive.Root
			data-slot="switch"
			className={cn(
				'data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 shadow-xs peer inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent outline-none transition-all focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
				size === 'lg' && 'my-[3px] h-[1.40rem] w-10',
				variant === 'primary' && 'data-[state=unchecked]:bg-primary/30! shadow-none',
				className,
			)}
			{...props}
		>
			<SwitchPrimitive.Thumb
				data-slot="switch-thumb"
				className={cn(
					'bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0',
					size === 'lg' && 'size-5',
					variant === 'primary' && 'data-[state=unchecked]:bg-background!',
				)}
			/>
		</SwitchPrimitive.Root>
	);
}

export { Switch };
